import { render, staticRenderFns } from "./DesignResponsibleForm.vue?vue&type=template&id=54780c42&"
import script from "./DesignResponsibleForm.vue?vue&type=script&lang=js&"
export * from "./DesignResponsibleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports